import React from 'react';

import { Button, TitleWithDescription } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import classes from './ChangePasswordRow.module.scss';
import { loggedInUserDataStore } from '../../../../../../../../shared/stores/loggedInUserDataStore';
import { getDescriptionInfo } from './utils/getDescriptionInfo';

type ChangePasswordRowProps = {
  onPasswordChange: () => void;
};

const ChangePasswordRow = observer(({ onPasswordChange }: ChangePasswordRowProps) => {
  const { getUserRole } = loggedInUserDataStore;

  const userRole = getUserRole();

  const { title, description } = getDescriptionInfo(userRole);
  return (
    <div className={classes.row}>
      <TitleWithDescription
        title={title}
        description={description}
        titleFont="body-14-bold"
        className={classes.title}
      />
      <Button variant="outlined" size="small" onClick={onPasswordChange}>
        Change Password
      </Button>
    </div>
  );
});

export { ChangePasswordRow };
